module.exports = __webpack_public_path__ + "img/zhongduanhui.9b2349d4.png";